const header = require('./includes/header')
const homepage = require('./pages/homepage');
const aBetterWorld = require('./pages/a-better-world');
const blog = require('./pages/blog');
const lab = require('./pages/lab');
const work = require('./pages/work');
const animations = require('./includes/animations');
const labdetail = require('./pages/labdetail');

$("document").ready(function () {
    header();
    homepage();
    aBetterWorld();
    blog();
    lab();
    work();
    labdetail();
    animations();
    // new LazyLoad({});
})

$(window).resize(function () {

})
